import { useEffect } from 'react'
import { useThemeStore } from '@/shared/stores/theme-store'

interface ThemeProviderProps {
  children: React.ReactNode
}

export function ThemeProvider({ children }: ThemeProviderProps) {
  const { theme, resolvedTheme } = useThemeStore()

  useEffect(() => {
    const root = document.documentElement
    const resolved = resolvedTheme()

    root.classList.remove('light', 'dark')
    root.classList.add(resolved)

    // Listen for system preference changes when theme is 'system'
    if (theme !== 'system') return

    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)')
    const handler = (e: MediaQueryListEvent) => {
      root.classList.remove('light', 'dark')
      root.classList.add(e.matches ? 'dark' : 'light')
    }

    mediaQuery.addEventListener('change', handler)
    return () => mediaQuery.removeEventListener('change', handler)
  }, [theme, resolvedTheme])

  return <>{children}</>
}
